import { FC, useEffect, useState } from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWater } from "@fortawesome/free-solid-svg-icons";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";
import { Geometry, Point } from "ol/geom";
import { map } from "../mainLayer/MainLayer";
import { LocationMarkerPopup } from "../mainLayer/MainWindow";
import Overlay from "ol/Overlay.js";
import SensorsPopUp from "./SensorsPopUp";
import ReactDOM from "react-dom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import { Coordinate } from "ol/coordinate";
import AddRiverLayer from "./AddRiverLayer";
import { Circle, Fill, Text } from "ol/style";
import { ThemeProvider, useTheme } from "../theme/ThemeContext";
import { useLayout } from "../layout/LayoutContext";
import {
  airQualityMap,
  openWindowsAirQualityMap,
} from "../mainLayer/airQuality/airQuality";
import { useMenu } from "../roundMenuContext/roundMenuContext";
import { useAllWeatherContext } from "../provider/AllWeatherProvider";
import safe from "../assets/sensor_marker.png";
import caution from "../assets/sensor_marker_caution.png";
import warning from "../assets/sensor_marker_warning.png";
import critical from "../assets/sensor_marker_critical.png";
import {
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../mainLayer/earlyWarning/ShowEarlyWarning";
import {
  HzSidebarMap,
  openWindowsHzMap,
} from "../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import { useRiverContext } from "../provider/RiverProvider";
import {
  openWindowsRainfallMap,
  rainfallMap,
} from "../mainLayer/rainfall/Rainfall";

export interface RiverSensor {
  id: string;
  latitude: number;
  longitude: number;
  name: string;
  threshold_critical: number;
  threshold_cautious: number;
  threshold_warning: number;
  river: string;
}

export interface RiverDetails {
  sensorId: string | null;
  name: string | null;
  cautionLevel: number | null;
  warningLevel: number | null;
  criticalLevel: number | null;
  coordinates: Coordinate | null;
}

const rivers: RiverDetails[] = [];
export const riverMap: Map<string, RiverDetails> = new Map();
export var layerButtonValue = "";
export var isClassic = false;

interface RiverSensorsProps {
  senddValueFromRiverSensorMenu: (value: string) => void;
  getVoiceRecognitionValue: string;
  openModular: (value: string) => void;
  setRiverSensorRender: (value: boolean) => void;
  sensorType: (value: string) => void;
  sidebarOpen: (value: boolean) => void;
  minMenuRiver: boolean;
  minMenuRiverLeft: (value: boolean) => void;
}
export const openWindowsMapRiver = new Map<string, string>();

const RiverSensors: React.FC<RiverSensorsProps> = ({
  senddValueFromRiverSensorMenu,
  getVoiceRecognitionValue,
  openModular,
  setRiverSensorRender,
  sensorType,
  sidebarOpen,
  minMenuRiver,
  minMenuRiverLeft,
}) => {
  const [riverSensors, setRiverSensors] = useState<RiverSensor[]>([]);
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [isClickedMini, setIsClickedMini] = useState<boolean>(true);
  const { theme } = useTheme();
  const { layout } = useLayout();
  const { menu } = useMenu();
  const { setMarker } = useAllWeatherContext();
  const {
    RiverOpenSidebarMap,
    removeFromRiverOpenSidebarMap,
    clearRiverOpenSidebarMap,
    setRiverOpenSidebarMap,
    setIsLeftkeyClickRiver,
    setIsLeftRiver,
    isMinEyeClickRiver,
    setIsMinEyeClickRiver,
  } = useRiverContext();
  const [hoveredRiverSensor, setHoveredRiverSensor] = useState(false);
  const [render, setRender] = useState(false);

  const handleButtonClick = () => {
    LocationMarkerPopup("river");
    setIsClicked((prevState) => !prevState);
    fetchData();
    if (!isClicked) {
      const entries = Array.from(RiverOpenSidebarMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsMapRiver.set(sensorId!, "close");
        }
      });
      clearRiverOpenSidebarMap();
    }
  };

  useEffect(() => {
    if (menu === "River Sensors") {
      handleButtonClick();
    }
  }, [menu]);

  useEffect(() => {
    if (isMinEyeClickRiver) {
      handleButtonClick();
    }
  }, [minMenuRiver]);

  useEffect(() => {
    if (getVoiceRecognitionValue === "open river sensors") {
      LocationMarkerPopup("river");
      setIsClicked((prevState) => !prevState);
      fetchData();
    } else if (getVoiceRecognitionValue === "close river sensors") {
      LocationMarkerPopup("river");
      setIsClicked((prevState) => !prevState);
      fetchData();
    }

    openPopupWithVoice(getVoiceRecognitionValue);
  }, [getVoiceRecognitionValue]);

  useEffect(() => {
    if (!isClicked) {
      senddValueFromRiverSensorMenu("River Sensor");
      minMenuRiverLeft(false);
    } else {
      senddValueFromRiverSensorMenu("");
      minMenuRiverLeft(true);
    }
  }, [isClicked]);

  const toggleSensorVisibility = () => {
    setRender((prevRender) => {
      const newRender = !prevRender;
      setRiverSensorRender(newRender);
      return newRender;
    });
  };

  useEffect(() => {
    if (layout === "hawk eye") {
      isClassic = false;
    } else if (layout === "modular") {
      isClassic = true;
    }
    layerButtonValue = layout;
  }, [layout]);

  const fetchData = async () => {
    const RIVER_LEVEL_URL =
    process.env.REACT_APP_RIVER_LEVEL_URL;


    try {
      const response = await fetch(
        `${RIVER_LEVEL_URL}`
      );
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: RiverSensor[] = responseData;

        setRiverSensors(data);
        createOpenPopupmap(data);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createOpenPopupmap = (data: RiverSensor[]) => {
    data.forEach((incident) => {
      openWindowsMapRiver.set(incident.id, "close");
    });
  };

  useEffect(() => {
    if (riverSensors.length > 0) {
      createMapWithMarkers();
    }
  }, [riverSensors]);

  const fetchSensorCurrentValue = async (
    id: string
  ): Promise<number | null> => {
    const RIVER_LEVEL_DATA_URL = process.env.REACT_APP_RIVER_LEVEL_DATA_URL;
    try {
      const response = await fetch(
        `${RIVER_LEVEL_DATA_URL}${id}`
      );
      const responseData = await response.json();

      if (responseData && typeof responseData.level === "number") {
        return responseData.level;
      } else {
        console.error(
          "Invalid response data format or missing level:",
          responseData
        );
        return null;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const createMapWithMarkers = async () => {
    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const sensorMarker = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: safe,
        scale: 0.27,
      }),
    });

    const sensorCaution = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: caution,
        scale: 0.27,
      }),
    });

    const sensorWarning = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: warning,
        scale: 0.27,
      }),
    });

    const sensorCritical = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: critical,
        scale: 0.27,
      }),
    });

    const sensorLevels = await Promise.all(
      riverSensors.map(async (marker) => {
        const level = await fetchSensorCurrentValue(marker.id);
        return { marker, level };
      })
    );

    const newFeatures = sensorLevels.map(({ marker, level }) => {
      const point = new Point(fromLonLat([marker.longitude, marker.latitude]));

      const feature = new Feature({
        geometry: point,
        id: marker.id,
        name: marker.name,
        cautionLevel: marker.threshold_cautious,
        criticalLevel: marker.threshold_critical,
        warningLevel: marker.threshold_warning,
        riverName: marker.river,
      });

      let style;
      if (level !== null) {
        if (level < marker.threshold_cautious) {
          style = sensorMarker;
        } else if (level < marker.threshold_warning) {
          style = sensorCaution;
        } else if (level < marker.threshold_critical) {
          style = sensorWarning;
        } else if (marker.threshold_critical < level) {
          style = sensorCritical;
        } else if (level === 0) {
          style = sensorMarker;
        }
      } else {
        style = sensorMarker;
      }
      feature.setStyle(style);
      // feature.set("initialStyle", style);

      return feature;
    });
    vectorSource.addFeatures(newFeatures);

    map.on("click", (evt) => {
      const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });

      if (feature) {
        setMarker("clickMarker");
      }
      const value = feature
        ? openWindowsMapRiver.get(feature.get("id"))
        : undefined;
      //to uniquely open certain type popup
      if (
        feature &&
        feature.get("name") &&
        feature.get("cautionLevel") &&
        value === "close"
      ) {
        const geometry = feature.getGeometry() as Point;
        const coordinates = geometry.getCoordinates();
        const sensorId = feature.get("id");
        const name = feature.get("name");
        const cautionLevel = feature.get("cautionLevel");
        const warningLevel = feature.get("warningLevel");
        const criticalLevel = feature.get("criticalLevel");
        if (name) {
          // LocationMarkerPopup("river");
          openWindowsMapRiver.set(sensorId, "open");
          showPopup(
            sensorId,
            coordinates,
            name,
            cautionLevel,
            warningLevel,
            criticalLevel
          );
          if (layerButtonValue === "hawk eye") {
            const entries = Array.from(RiverOpenSidebarMap.values());
            const lastEntryIndex = entries.length - 1;
            entries.forEach((details, index) => {
              const { coordinates, sensorId } = details;
              if (coordinates) {
                removeOverlay(sensorId!);
                if (index === lastEntryIndex) {
                  addOverlayClickItemLast(sensorId!, coordinates);
                } else {
                  addOverlayClickItem(sensorId!, coordinates);
                }
              }
            });
          }
        }
      }
      setTimeout(() => {
        setMarker("notClickMarker");
      }, 500);
    });
    AddRiverLayer(vectorLayer, isClicked, "riversensor");
  };

  useEffect(() => {
    const entries = Array.from(RiverOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [RiverOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";
    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const openPopupWithVoice = async (river: string) => {
    const marker = riverSensors.find((sensor) => sensor.id === river);
    if (marker) {
      const coordinates: Coordinate = [marker.longitude, marker.latitude];
      showPopup(
        marker.id,
        coordinates,
        marker.name,
        marker.threshold_cautious,
        marker.threshold_warning,
        marker.threshold_critical
      );
    }
  };

  const handleClose = (incidentId: string) => {
    openWindowsMapRiver.set(incidentId, "close");
    if (riverMap.has(incidentId)) {
      riverMap.delete(incidentId);
    }
    if (RiverOpenSidebarMap.has(incidentId)) {
      RiverOpenSidebarMap.delete(incidentId);
    }
    removeFromRiverOpenSidebarMap(incidentId);
    const entries = Array.from(RiverOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  };

  const showPopup = (
    sensorId: string | null,
    coordinates: Coordinate | null,
    name: string | null,
    cautionLevel: number | null,
    warningLevel: number | null,
    criticalLevel: number | null
  ) => {
    toggleSensorVisibility();
    sensorType("riverSensor");
    // airQualityMap.clear();
    if (layerButtonValue === "modular") {
      const entries = Array.from(airQualityMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsAirQualityMap.set(sensorId!, "close");
        }
      });
      const entriesEws = Array.from(EWSSidebarMap.values());
      entriesEws.forEach((details, index) => {
        const { coordinates, active_pcode } = details;
        if (coordinates) {
          removeOverlay(active_pcode!);
          openEwsWindowsMap.set(active_pcode!, "close");
        }
      });
      const entriesHz = Array.from(HzSidebarMap.values());
      entriesHz.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsHzMap.set(sensorId!, "close");
        }
      });
      const entriesRain = Array.from(rainfallMap.values());
      entriesRain.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsRainfallMap.set(sensorId!, "close");
        }
      });
    }
    if (
      sensorId &&
      coordinates &&
      name &&
      cautionLevel &&
      warningLevel &&
      criticalLevel
    ) {
      // map.getOverlays().clear();
      if (layerButtonValue === "hawk eye") {
        const popupElement = document.createElement("riverSensor");

        ReactDOM.render(
          <SensorsPopUp
            sensorId={sensorId}
            name={name}
            cautionLevel={cautionLevel}
            warningLevel={warningLevel}
            criticalLevel={criticalLevel}
            onClose={handleClose}
          />,
          popupElement
        );
        const overlay = new Overlay({
          element: popupElement,
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        });
        overlay.setPosition(coordinates);
        map.addOverlay(overlay);

        const newRiver: RiverDetails = {
          sensorId: sensorId,
          name: name,
          cautionLevel: cautionLevel,
          warningLevel: warningLevel,
          criticalLevel: criticalLevel,
          coordinates: coordinates,
        };
        riverMap.set(newRiver.sensorId!, newRiver);
        setRiverOpenSidebarMap(newRiver.sensorId!, newRiver);
      } else if (layerButtonValue === "modular") {
        isClassic = true;
        const newRiver: RiverDetails = {
          sensorId: sensorId,
          name: name,
          cautionLevel: cautionLevel,
          warningLevel: warningLevel,
          criticalLevel: criticalLevel,
          coordinates: coordinates,
        };
        openModular("modularOpened");
        riverMap.set(newRiver.sensorId!, newRiver);
        setRiverOpenSidebarMap(newRiver.sensorId!, newRiver);
        sidebarOpen(true);
      }
    }
  };

  useEffect(() => {
    if (isClickedMini) {
      setIsLeftRiver(false);
    } else {
      setIsLeftRiver(true);
    }
  }, [isClickedMini]);

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          setIsMinEyeClickRiver(false);
          handleButtonClick();
          setIsLeftkeyClickRiver(true);
          setIsClickedMini((prevState) => !prevState);
        }}
        onTouchStart={() => {
          handleButtonClick();
          setIsLeftkeyClickRiver(true);
          setIsClickedMini((prevState) => !prevState);
        }}
      >
        <div
          onMouseEnter={() => setHoveredRiverSensor(true)}
          onMouseLeave={() => setHoveredRiverSensor(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon size="1x" icon={faWater} className="leftside-icon" />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? hoveredRiverSensor
                  ? "leftsidemenulist-btn-tooltip-hover-light"
                  : "leftsidemenulist-btn-tooltip-light"
                : "leftsidemenulist-btn-tooltip-clicked-light"
            }
            onMouseEnter={() => setHoveredRiverSensor(true)}
            onMouseLeave={() => setHoveredRiverSensor(false)}
          >
            River Sensor
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? hoveredRiverSensor
                  ? "leftsidemenulist-btn-tooltip-hover"
                  : "leftsidemenulist-btn-tooltip"
                : "leftsidemenulist-btn-tooltip-clicked"
            }
            onMouseEnter={() => setHoveredRiverSensor(true)}
            onMouseLeave={() => setHoveredRiverSensor(false)}
          >
            River Sensor
          </div>
        )}
      </div>
    </>
  );
};

export default RiverSensors;
